import DropdownOptionItem from "../ui/dropdown-option-item";
import NavNewPageItem from "../ui/nav-new-page-item";
import { useState, useContext, useRef } from "react";
import TableContext from "../../contexts/table-context";
import SideBarContext from "../../contexts/side-bar-context";
import SidebarDropdown from "../ui/sidebar-dropdown";
import {useRouter} from 'next/router';
import { useTranslations } from "next-intl";

const CreateNewTable = () => {
    const triggerRef = useRef(null);
    const { createTable } = useContext(TableContext);
    const {toggleSideBar} = useContext(SideBarContext);
    const [isOpen, setIsOpen] = useState(false);
    const router = useRouter();
    const isFeatureEnabled = router.query.enable === 'all'
    const t = useTranslations('nav');
    const tTable = useTranslations('table');

    const tableTranslations = {
        columns: {
            task: tTable('columns.task'),
            status: tTable('columns.status'),
            assignedTo: tTable('columns.assignedTo'),
            text: tTable('columns.text'),
            name: tTable('columns.name'),
            objectives: tTable('columns.objectives'),
            keyResults: tTable('columns.keyResults')
        },
        statusOptions: {
            toDo: tTable('statusOptions.toDo'),
            inProgress: tTable('statusOptions.inProgress'),
            done: tTable('statusOptions.done')
        },
        names: {
            kanban: tTable('names.kanban'),
            untitledTable: tTable('names.untitledTable'),
            untitledDocument: tTable('names.untitledDocument'),
            okrs: tTable('names.okrs'),
            newFolder: tTable('names.newFolder')
        }
    };

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    }
    const types = [
        { name: "Blank Table", type: "blank", available: true, icon:"table" },
        { name: "Kanban", type: "kanban", available: true, icon:"kanban" },
        { name: "Page", type: "document", available: true, icon:"file-text", tag:"Unstable" },
        { name: "OKRs", type: "okrs", available: true, icon:"list-collapse" },
        // { name: "Payroll", type: "payroll", available: false, icon:"banknote" },
        { name: "Generate using AI", type: "ai", available: false, icon: "sparkles" },
    ];

    return (
        <div ref={triggerRef} className="relative z-">
            <NavNewPageItem isOpen={isOpen} onClick={toggleDropdown} icon="plus">{t('newPage')}</NavNewPageItem>
            <SidebarDropdown triggerRef={triggerRef} position="right" isOpen={isOpen} toggleDropdown={toggleDropdown} additionalclasses='!left-[22px] lg:!left-[240px]' >
                {types.map((type, index) => (
                    <div key={type.type}>
                        {index === types.length - 1 && <div className="border-t-[1px] custom-border-grey-50 my-[4px]"></div>}
                        <DropdownOptionItem
                            onClick={() => { createTable(type.type, null, null, null, tableTranslations); toggleDropdown(); 
                                if (window.innerWidth < 1024) {
                                    toggleSideBar();
                                  }
                             }}
                            isDisabled={!type.available}
                            tag={type.tag}
                            toggleDropdown={toggleDropdown}
                            icon={type.icon}
                        >
                            {type.name}
                        </DropdownOptionItem>
                    </div>
                ))}
            </SidebarDropdown>
        </div>
    );
};

export default CreateNewTable;